import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import VoznjeTable from "Views/Prijevoznici/Voznje/VoznjeTable";

const PrijevozniciVoznjePage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <VoznjeTable />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PrijevozniciVoznjePage;
